import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Customer } from "@/services/types/user";
import { customerApi } from "@/services/api/customers";

interface AgentCustomerViewState {
  selectedCustomer: Customer | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: AgentCustomerViewState = {
  selectedCustomer: null,
  isLoading: false,
  error: null,
};

// Async thunk to fetch customer by ID
export const fetchCustomerById = createAsyncThunk(
  "agentCustomerView/fetchCustomerById",
  async (customerId: string, { rejectWithValue }) => {
    try {
      const response = await customerApi.getCustomerById(customerId);
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch customer"
      );
    }
  }
);

const agentCustomerViewSlice = createSlice({
  name: "agentCustomerView",
  initialState,
  reducers: {
    clearSelectedCustomer: (state) => {
      state.selectedCustomer = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCustomerById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selectedCustomer = action.payload;
        state.error = null;
      })
      .addCase(fetchCustomerById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearSelectedCustomer, clearError } = agentCustomerViewSlice.actions;
export default agentCustomerViewSlice.reducer;
